<template>
  <div>
    <el-dialog
      :title="title"
      :visible.sync="localVisible"
      width="70%"
      :before-close="handleClose"
    >
      <el-form :rules="rules" ref="form" size="small" :model="addForm" label-width="100px">
        <el-row :gutter="24">

          <el-col :span="8">
            <el-form-item label="规格名称">
              <el-input width="400" :disabled="true"  v-model="addForm.attr_name" type="text"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="规格值">
              <el-input width="400"  v-model="addForm.name" type="text"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="24">
            <el-table
              :data="addForm.val"
            >
              <el-table-column label="规格值">
                <template slot-scope="scope">
                <span>
                  {{scope.row.name}}
                </span>
                </template>
              </el-table-column>
                            <el-table-column
                              label="操作"
                              width="180">
                              <template slot-scope="scope">
                                <el-button  type="text" size="mini" @click="delVal(scope.row)">删除</el-button>
                              </template>
                            </el-table-column>
            </el-table>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="onSubmit('form')">确定</el-button>
        <el-button size="small" @click="handleClose">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>

  export default {
    name:'eAttrVal',
    props: {
      visible: {
        type: Boolean,
        default: true,
      },
      formData: {
        type: Object,
        default: null,
      },
      title: {
        type: String,
        default: "",
      },
      closeForm: Function,
    },
    data() {
      return {
        addForm:{
          name:'',
          val:'',
          attr_name:'',
          pos_member_id:''
        },
        localVisible:false,
        valList:[],
        inputList:[{id:1,name:'选择输入'},{id:0,name:'手工输入'},],
        cateMenus:[],

        memberLoading:'',
        memberList:[],
        memberStates:[],

        lng_lat:'',

        areaList: [],

        rules: {

        },
        curShop: '',
        employee_id: '',
        name_cn: '',

        keywords: '',
        fileList: [],
        mList: [],
        pageNum: 1,
        pageSize: 10,
        isResouceone: false,

      }
    },

    mounted() {
      ///this.getList();

    },
    methods:{

      getCateMenus(){
        let _this = this;
        let params={
          access_token:sessionStorage.getItem('token'),
          company_id:sessionStorage.getItem('company_id'),
          shop_id:sessionStorage.getItem('shop_id')
        };
        this.$axios.goodsTypeTable(params).then((res)=>{
          if(res.code == 200) {
            _this.cateMenus=res.data;
          }
        });

      },
      delVal(e){
        let _this=this;
        this.$confirm('此操作将删除该记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const param = {
            operator_id: sessionStorage.getItem('user_id'),
            company_id:sessionStorage.getItem('company_id'),
            access_token:sessionStorage.getItem('token'),
            id: e.id,
          }
          this.$axios.goodsAttributesValDel(param).then(res=>{
            if(res.code == 200){
              _this.$message.success(res.msg);
              _this.closeForm();
            }else{
              _this.$message.error(res.msg);
            }
          }).catch(error=>{
            console.log(error);
          })
        }).catch(() => {
          // 点击取消:不删除了
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
          this.DataList()
        });
      },
      handleChangeAddress(row){
        console.log(row)
        let _this=this;
        const checkedNode =  this.$refs["cascaderAddr"].getCheckedNodes();
        _this.formData.province_id=checkedNode[0].path[0];
        _this.formData.city_id=checkedNode[0].path[1];
        _this.formData.district_id=checkedNode[0].path[2];
      },
      // 关闭
      handleClose() {
        //this.$refs["form"].resetFields();
        this.closeForm();
      },
      // 前置提交
      onSubmit(formName) {
        console.log(formName)
        // this.$refs[formName].validate((valid) => {
        //   if (valid) {
            this.submit();

        //   } else {
        //     return false;
        //   }
        // });
      },
      submit() {
        let params=this.formData;
        params.company_id=sessionStorage.getItem('company_id');
        params.access_token=sessionStorage.getItem('token');
        params.shop_id=sessionStorage.getItem('shop_id');
        console.log('----params',params)
        this.$axios.goodsAttributesValSave(params).then(res=>{
          if(res.code == 200){
            this.$message.success("保存成功");
            this.closeForm();
          }
        }).catch(error=>{
          this.$message.error("保存错误");
          console.log(error);
        })
      },

      getList(){
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
          pageNum: this.pageNum,
          pageSize: this.pageSize,
        }
        this.$axios.employeeList(param).then(res=>{
          if(res.code == 200){
            this.mList = res.data.data
            this.total = res.data.total
          }
        }).catch(error=>{
          console.log(error);
        })
      },
      clickChange(row){
        this.employee_id=row.id;
        this.name_cn=row.name_cn;
        console.log('row----',row);
      },
      handleBeforeUpload(){

      },
      uploadSuccess(){

      },
      uploadFile(){

      },
      chooseItem(){

      },

      memberRemoteMethod(query){
        if (query !== '') {
          this.memberLoading = true;
          let param={
            keyword:query,
            operator_id:sessionStorage.getItem('user_id'),
            company_id:sessionStorage.getItem('company_id'),
            access_token:sessionStorage.getItem('token'),
          }
          this.$axios.posMemberListP(param).then(res=>{
            if(res.code == 200){
              this.memberStates = res.data.data;
            }
          }).catch(error=>{
              console.log(error);
          })
          setTimeout(() => {
            this.memberLoading = false;
            this.memberList = this.memberSet.filter(item => { // 这里的this.list，换为this.applicantSet
              return item.name;
            });
          }, 1000);
        } else {
          this.memberList = [];
        }
      },
    },
    computed: {
      memberSet() {
        return this.memberStates.map(item => {
          return {id: `${item.id}`, name: `${item.merchant_name}`};
        });
      },
    },
    // 监听
    watch: {

     async visible(val) {
       this.localVisible=val;
        console.log('----val----',val)
        if (val) {
         if(this.formData.member){
           console.log('----merchant----',this.formData.member.merchant_name)
           await this.memberRemoteMethod(this.formData.member.merchant_name);
           this.addForm.pos_member_id=this.formData.member.id+'';
           console.log('----id----',this.formData.member.id)

           this.$refs['cascaderAddr'].inputValue=(this.formData.province?this.formData.province.region_name:'')+'-'+(this.formData.city?this.formData.city.region_name:'')+'-'+(this.formData.district?this.formData.district.region_name:'');



         }
          // if (this.formData.img) {
          //   console.log(this.formData, " this.formData");
          //   this.formData.img = [
          //     {
          //       name: this.formData.img,
          //       url: this.formData.img,
          //     },
          //   ];
          // }
        }
      },
    },
  }
</script>
<style lang="less" scoped>
  //https://www.yzktw.com.cn/post/1262748.html
  .upload_group {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;

    .upload_list {
      width: 120px;
      margin-right: 1rem;
    }

    /deep/.el-upload-dragger .el-upload__text {
      font-size: 10px;
      color: #409EFF;
    }

    /deep/.el-icon-upload:before {
      width: 40px !important;
      height: 40px !important;
    }

    .upload_list:last-child {
      margin-right: 0;
    }

    /deep/.el-upload-dragger {
      width: 100%;
      height: auto;
      padding: 20px 0;
      border: 1px solid #999;
    }

    /deep/.el-upload {
      width: 100%;
    }

    /deep/.el-upload-dragger .el-icon-upload {
      margin: 10px 0;
    }
  }
  .table_name:hover{
    color: #409EFF;
    cursor: pointer;
  }
</style>
